var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteReach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9102 17.6622L17.7899 15.3384C17.616 15.2089 17.3774 15.3783 17.4431 15.5859L17.7225 16.4631H6.2807L13.6549 9.08889L14.1853 10.1151C14.2846 10.3085 14.5738 10.2597 14.6048 10.045L15.168 6.19474C15.1893 6.04662 15.0625 5.91979 14.9144 5.94107L11.065 6.50429C10.8503 6.53534 10.8015 6.82449 10.9949 6.92382L11.8606 7.37085L4.52541 14.706V3.25447L5.47445 3.55693C5.68111 3.62256 5.85141 3.38486 5.72103 3.21013L3.3963 0.0898046C3.30672 -0.0299349 3.12756 -0.0299349 3.03797 0.0898046L0.714139 3.21013C0.584643 3.38397 0.754056 3.62256 0.961605 3.55693L2.04192 3.21279V17.7039C2.04192 18.3895 2.59804 18.9457 3.28366 18.9457H17.8103L17.4431 20.0978C17.3774 20.3045 17.6152 20.4748 17.7899 20.3444L20.9102 18.0197C21.0299 17.9301 21.0299 17.7509 20.9102 17.6614V17.6622Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteReach);
export default __webpack_public_path__ + "static/media/whiteReach.59d4c749297c91ffd31df25bab950b31.svg";
export { ForwardRef as ReactComponent };